import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './TermsOfService.css';

const splitHeadingLetters = (text) =>
  text.split('').map((character, index) => (
    <span
      key={`${text}-${index}`}
      className={`terms-heading-letter${character === ' ' ? ' is-space' : ''}`}
      style={{ '--letter-index': index }}
      aria-hidden="true"
    >
      {character === ' ' ? '\u00A0' : character}
    </span>
  ));

const TermsOfServicePage = () => {
  const [isHeadingVisible, setIsHeadingVisible] = useState(false);

  useEffect(() => {
    const timer = window.setTimeout(() => {
      setIsHeadingVisible(true);
    }, 80);

    return () => {
      window.clearTimeout(timer);
    };
  }, []);

  return (
    <div className="terms-of-service-page-wrapper">
      <div className="terms-of-service-page-container terms-of-service-page">
        <div className="terms-of-service-back-link">
          <Link to="/">&larr; Back to Home</Link>
        </div>

        <div className="terms-of-service-page-hero">
          <h1
            className={`terms-heading ${isHeadingVisible ? 'is-visible' : ''}`}
            aria-label="Terms of Service"
          >
            {splitHeadingLetters('Terms of Service')}
          </h1>
          <p>
            These Terms of Service govern your access to and use of BlackRoth
            platforms, products, and services. By using our services, you agree
            to comply with the terms, responsibilities, and operational policies
            outlined below.
          </p>
        </div>

        <section className="terms-of-service-page-section">
          <h2 className="terms-section-heading">Acceptance of Terms</h2>
          <p>
            By accessing or using BlackRoth services, you acknowledge that you
            have read, understood, and agreed to be bound by these terms. If you
            do not agree, you should discontinue use of the platform immediately.
          </p>
        </section>

        <section className="terms-of-service-page-section">
          <h2 className="terms-section-heading">User Responsibilities</h2>
          <p>
            Users are responsible for maintaining account confidentiality,
            complying with applicable laws, and ensuring that platform usage does
            not violate security, intellectual property, or operational policies.
          </p>
        </section>

        <section className="terms-of-service-page-section">
          <h2 className="terms-section-heading">Service Usage &amp; Limitations</h2>
          <p>
            BlackRoth grants a limited, non-transferable license to access and
            use services for authorized business purposes. Unauthorized
            distribution, reverse engineering, or misuse of the platform is
            strictly prohibited.
          </p>
        </section>

        <section className="terms-of-service-page-section">
          <h2 className="terms-section-heading">Modifications &amp; Termination</h2>
          <p>
            We reserve the right to modify services, update terms, or suspend
            access in cases of policy violations or operational requirements.
            Continued usage constitutes acceptance of any revised terms.
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsOfServicePage;
